<template>
  <Record :title="site.name">
    <Row>
      <Column :xs="4">
        <Set icon="info" :label="$t('name')">
          {{ site.name }}
        </Set>
      </Column>
      <Column :xs="4">
        <Set icon="site" :label="$t('siteUrl')">
          {{ site.url }}
        </Set>
      </Column>
      <Column :xs="4">
        <Set icon="key" :label="$t('jwtExpires')">
          {{ site.jwtExpiresAt | relativeTime }}
        </Set>
      </Column>
    </Row>
    <RecordActions
      v-if="isModeratorOrUp"
      slot="actions"
      :doShowDelete="false"
      name="site"
      :record="site"
      routeName="Site">
      <Tag
        v-if="isJwtExpired"
        slot="tail"
        class="danger">
        {{ $t("jwtExpired") }}
      </Tag>
    </RecordActions>
  </Record>
</template>

<script>
import Record from '@components/Record'
import RecordActions from '@components/RecordActions'
import Set from '@components/Set'
import { getters } from '@utils'

export default {
  components: { Record, RecordActions, Set },
  props: {
    site: Object,
  },
  computed: {
    isModeratorOrUp() {
      return this.hasRole('>=MODERATOR')
    },
    isJwtExpired() {
      return new Date(this.site.jwtExpiresAt) < Date.now()
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "name": "Site name",
    "siteUrl": "Site URL",
    "jwt": "JWT token",
    "jwtExpired": "JWT expired",
    "jwtExpires": "JWT expires"
  }
}
</i18n>
